(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/use-filtered-marks-info-choices.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/use-filtered-marks-info-choices.js');
"use strict";

const {
  useMemo
} = React;
const {
  selectTipsinfoSupport
} = svs.components.tipsen.engine.selectors.engineSelectors;
const {
  useSelector
} = ReactRedux;
const {
  tipsinfo
} = svs.components.tipsen.engine.constants;
const {
  selectOutcomeInfoChoises,
  selectResultOutcomeInfoChoises
} = svs.components.tipsen.selectors;
const useFilteredOutcomeInfoChoises = isResult => {
  const resultOutcomeInfoChoisesFromStore = useSelector(selectResultOutcomeInfoChoises);
  const outcomeInfoChoisesFromStore = useSelector(selectOutcomeInfoChoises);
  const tipsinfoSupport = useSelector(selectTipsinfoSupport);
  return useMemo(() => {
    const outcomeInfoChoises = [];
    const outcomeInfoChoisesOptions = {
      [tipsinfo.OutcomeLabel]: '1X2',
      [tipsinfo.SvenskaFolket]: 'Svenska folket (%)'
    };
    const outcomeInfoChoisesKeys = Object.keys(outcomeInfoChoisesOptions);
    for (const key of outcomeInfoChoisesKeys) {
      if (tipsinfoSupport[key]) {
        var _outcomeInfoChoisesOp;
        outcomeInfoChoises.push({
          isSelected: isResult ? resultOutcomeInfoChoisesFromStore.displayResult === key : outcomeInfoChoisesFromStore.display === key,
          key,
          title: (_outcomeInfoChoisesOp = outcomeInfoChoisesOptions[key]) !== null && _outcomeInfoChoisesOp !== void 0 ? _outcomeInfoChoisesOp : ''
        });
      }
    }
    return outcomeInfoChoises;
  }, [isResult, resultOutcomeInfoChoisesFromStore.displayResult, outcomeInfoChoisesFromStore.display, tipsinfoSupport]);
};
setGlobal('svs.components.tipsen.tipsinfo.useFilteredOutcomeInfoChoises', useFilteredOutcomeInfoChoises);

 })(window);